import {
  UserInvitationStatusSchema,
  type UserInvitationStatus as GeneratedUserInvitationStatus
} from '~/services/api/generated'

// Mirrors backend App\Enums\UserInvitationStatus

export type UserInvitationStatus = GeneratedUserInvitationStatus

export const UserInvitationStatus = {
  NONE: UserInvitationStatusSchema.enum.none,
  PENDING: UserInvitationStatusSchema.enum.pending,
  ACCEPTED: UserInvitationStatusSchema.enum.accepted,
  CANCELLED: UserInvitationStatusSchema.enum.cancelled
} satisfies Record<string, GeneratedUserInvitationStatus>

export const UserInvitationStatusValues: readonly GeneratedUserInvitationStatus[] = [
  UserInvitationStatusSchema.enum.none,
  UserInvitationStatusSchema.enum.pending,
  UserInvitationStatusSchema.enum.accepted,
  UserInvitationStatusSchema.enum.cancelled
]
